import React, { useContext, useEffect, useState } from "react";
 import Box from '@mui/material/Box';
 import { useNavigate } from "react-router-dom";
/*import {
    GetCountries,
    GetState,
    GetCity,
    GetLanguages,
    GetRegions,
    GetPhonecodes //async functions
} from "react-country-state-city";*/
//import "react-country-state-city/dist/react-country-state-city.css";
import { FormControl, FormHelperText, Input, InputLabel, MenuItem, Select } from "@mui/material";
import PhoneInput from 'react-phone-number-input'
import 'react-phone-number-input/style.css';
import { emailValidate } from "../../validators/emailValidate";
import { ToastContainer, toast } from 'react-toastify';
import axios  from "axios";
import "../../styles/profile.css";

const ProfileForm = (props) => {
     let basicUserInfo2 = localStorage.getItem("activeUser");
    basicUserInfo2 = (basicUserInfo2) ? JSON.parse(basicUserInfo2) : [];
    const handleClose = props.handleClose;

    const [currentUserRole, setCurrentUserRole] = useState(basicUserInfo2); 
    let todaydate = new Date();
    let todaydateMDY = `${todaydate.getFullYear()}-${todaydate.getMonth() + 1}-${todaydate.getDate()} ${todaydate.getHours()}:${todaydate.getMinutes()}:${todaydate.getSeconds()}`;
    console.log(todaydateMDY);
    const navigate = useNavigate();

 
    const [mobile, setMobile] = useState(currentUserRole.mobile);
    const [name, setName] = useState(currentUserRole.name);

    const [nameErr, setNameErr] = useState(false);
     const [mobileErr, setMobileErr] = useState(false);
    const [countryErr, setCountryErr] = useState(false);
    const [stateErr, setStateErr] = useState(false);
    const [cityErr, setCityErr] = useState(false);
    const [addressErr, setAddressErr] = useState(false);
    const [pincodeErr, setPincodeErr] = useState(false);

    const [countryid, setCountryid] = useState(currentUserRole.country);
    const [state_id, setStateid] = useState(currentUserRole.state);
     const [city_id, setCityID] = useState(currentUserRole.city);
    const [pincode, setPincode] = useState(currentUserRole.pincode);

    const [address, setAddress] = useState(currentUserRole.address);
     const [stateList, setStateList] = useState([]);
    const [cityList, setCityList] = useState([]);


    const sendRequest = async () => {
        if (pincode != "" && name != "" && mobile != "" && mobile.length == 13 && city_id != '' && state_id != '' && address != "") {
            let formData = {
                name: name,
                mobile: mobile,
                country:countryid,
                city: city_id,
                state: state_id,
                address: address,
                pincode: pincode,
                };

                axios.post(process.env.REACT_APP_API_BASE_URL+"UpdateProfile/"+basicUserInfo2.id, { ...formData })
                    .then((res) => {
                          if(res.data.status === true){
                          toast.success('profile info updatd sucessfully!!');
                          localStorage.setItem('activeUser', JSON.stringify({...basicUserInfo2, ...formData}));
                          handleClose();
                          setTimeout(() => {
                            navigate('/'+basicUserInfo2.user_type+'/profile');
                          }, 1000);
                      }
                      else{
                          toast.success("something went wrong...")
                      }
                    })
                    .catch(err => {
                      console.error(err);
                      toast.error(err);
                    }); 

        } else {
            if (mobile == "" || mobile != undefined && mobile.length != 13) {
                setMobileErr(true);
            }
            if (name == "") {
                setNameErr(true);
            }
            
            if (city_id == "") {
                setCityErr(true);
            }
            if (state_id == "") {
                setStateErr(true);
            }
            if (address == "") {
                setAddressErr(true);
            }

            if (pincode == "") {
                setPincodeErr(true);
            }
        }
    };
  //  const notify = (message) => toast(message);
 

    useEffect(() => {
        async function loadData() {
           
            axios.get(process.env.REACT_APP_API_BASE_URL+"users/"+basicUserInfo2.id)
                .then((res) => {
                    console.log(res.data);
                    if(res.data.status === true){
                     
                    let userinfo = res.data;
                      
                     setMobile(userinfo.mobile);
                    setName(userinfo.name);
                    setCountryid(userinfo.country);
                    setStateid(userinfo.state);
                    setCityID(userinfo.city);
                    setPincode(userinfo.pincode);
                    setAddress(userinfo.address);
                  }
                  else{
                      toast.success("something went wrong...")
                  }
                })
                .catch(err => {
                  console.error(err);
                  toast.error(err);
                });
          
           
        }
        loadData();
    }, []);



    return (
        <Box sx={{ p: 2.5, pb: 0 }}>
            <ToastContainer></ToastContainer>
                   
            <div className="  register   pt-3">
                <h4 > Profile Update</h4>
                <div className="register__container p-5">

                    <div className="container row">

                        <div className="col-md-6 col-lg-6 col-sm-12 col-xs-12">


                            <FormControl fullWidth>
                                <InputLabel htmlFor="my-input">Name</InputLabel>
                                <Input
                                    error={nameErr}
                                    aria-describedby="my-helper-text"
                                    type="text"
                                    onChange={(e) => {
                                        setName(e.target.value)
                                        if (e.target.value != "") {
                                            setNameErr(false);
                                        } else {
                                            setNameErr(true);
                                        }
                                    }}
                                    name="name"
                                    value={name}
                                    required
                                />
                                {nameErr && (
                                    <FormHelperText id="my-helper-text" error={true}>
                                        Please enter Name.
                                    </FormHelperText>
                                )}
                            </FormControl>
                        </div>
                
                        <div className="col-md-6 col-lg-6 col-sm-12 col-xs-12">


                            <FormControl fullWidth>
                                <InputLabel htmlFor="my-input">Mobile Number</InputLabel>
                                <br />
                                <PhoneInput
                                    error={mobileErr}
                                    id="my-input"
                                    aria-describedby="my-helper-text"
                                    international
                                    countryCallingCodeEditable={false}
                                    defaultCountry="IN"
                                    placeholder="Enter phone number"
                                    value={mobile}
                                    onChange={(e) => {
                                        setMobile(e);
                                        if (e == "" || (e != undefined && e.length != 13)) {
                                            setMobileErr(true);
                                        } else {
                                            setMobileErr(false);
                                        }
                                    }}

                                />
                                {mobileErr && (
                                    <FormHelperText id="my-helper-text" error={true}>
                                        Please enter valid Mobile number.
                                    </FormHelperText>
                                )}
                            </FormControl>
                        </div>
                        <div className="col-md-6 col-lg-6 col-sm-12 col-xs-12 ">


<FormControl fullWidth>

    <InputLabel htmlFor="my-input3">Country</InputLabel>
    <Input
        error={countryErr}
        aria-describedby="my-helper-text"
        type="text"
        onChange={(e) => {
            setCountryid(e.target.value)
            if (e.target.value != "") {
                setCountryErr(false);
            } else {
                setCountryErr(true);
            }
        }}
        name="countryid"
        value={countryid}
        required
    />
     {countryErr && (
                                    <FormHelperText id="my-helper-text" error={true}>
                                        Please enter country name.
                                    </FormHelperText>
                                )}
    </FormControl>
    </div>
                        <div className="col-md-6 col-lg-6 col-sm-12 col-xs-12 ">


                            <FormControl fullWidth>

                                <InputLabel htmlFor="my-input3">State</InputLabel>
                                <Input
                                    error={stateErr}
                                    aria-describedby="my-helper-text"
                                    type="text"
                                    onChange={(e) => {
                                        setStateid(e.target.value)
                                        if (e.target.value != "") {
                                            setStateErr(false);
                                        } else {
                                            setStateErr(true);
                                        }
                                    }}
                                    name="state_id"
                                    value={state_id}
                                    required
                                />
                                {/* <Select
                                    id="my-input3"
                                    value={state_id} error={stateErr} name="state_id" aria-describedby="my-helper-text"
                                    variant="standard"
                                    onChange={(e: any) => {
                                        setStateID(e.target.value);

                                        if (e.target.value != "") {
                                            setStateErr(false);
                                            const state: any = stateList[e.target.value]; //here you will get full state object.
                                            console.log('state', state.name);
                                            setStateid(state.name);
                                            GetCity(countryid, state.id).then((result: any) => {
                                                setCityList(result);
                                            });
                                        } else {
                                            setStateid("");
                                            setStateErr(true);
                                        }

                                    }}

                                ><MenuItem key={""} value={""}>
                                        Select State
                                    </MenuItem>
                                    {stateList.map((item: any, index) => (
                                        <MenuItem key={index} selected={(item.name == 'Telangana') ? true : false} value={index}>
                                            {item.name}
                                        </MenuItem>
                                    ))}
                                </Select>*/}
                                {stateErr && (
                                    <FormHelperText id="my-helper-text" error={true}>
                                        Please choose State.
                                    </FormHelperText>
                                )}
                            </FormControl>
                        </div>
                        <div className="col-md-6 col-lg-6 col-sm-12 col-xs-12 ">

                            <FormControl fullWidth>
                                <InputLabel htmlFor="my-input4">City</InputLabel>
                                <Input
                                    error={cityErr}
                                    aria-describedby="my-helper-text"
                                    type="text"
                                    onChange={(e) => {
                                        setCityID(e.target.value)
                                        if (e.target.value != "") {
                                            setCityErr(false);
                                        } else {
                                            setCityErr(true);
                                        }
                                    }}
                                    name="city_id"
                                    value={city_id}
                                    required
                                />
                                {/*<Select error={cityErr} id="my-input4"
                                    value={city_id} name="city_id" aria-describedby="my-helper-text"
                                    variant="standard"
                                    onChange={(e: any) => {
                                        setCityID(e.target.value);
                                        if (e.target.value != "") {
                                            const city: any = cityList[e.target.value]; //here you will get full city object.
                                            console.log('city', city.name);
                                            setCityid(city.name);
                                            setCityErr(false);
                                        } else {
                                            setCityErr(true);
                                            setCityid("");

                                        }
                                    }}
                                >
                                    <MenuItem value="">select City</MenuItem>
                                    {cityList.map((item: any, index) => (
                                        <MenuItem key={index} selected={(item.name == cityid) ? true : false} value={index}>
                                            {item.name}
                                        </MenuItem>
                                    ))}

                                </Select>*/}
                                {cityErr && (
                                    <FormHelperText id="my-helper-text" error={true}>
                                        Please add City.
                                    </FormHelperText>
                                )}
                            </FormControl>
                        </div>
                        <div className="col-md-6 col-lg-6 col-sm-12 col-xs-12">

                            <FormControl fullWidth>
                                <InputLabel htmlFor="my-input">Address</InputLabel>
                                <Input
                                    error={addressErr}
                                    aria-describedby="my-helper-text"
                                    type="text"
                                    onChange={(e) => {
                                        setAddress(e.target.value)
                                        if (e.target.value != "") {
                                            setAddressErr(false);
                                        } else {
                                            setAddressErr(true);
                                        }
                                    }}
                                    name="address"
                                    value={address}
                                    required
                                />
                                {addressErr && (
                                    <FormHelperText id="my-helper-text" error={true}>
                                        Please enter valid Address.
                                    </FormHelperText>
                                )}
                            </FormControl>
                        </div>
                        <div className="col-md-6 col-lg-6 col-sm-12 col-xs-12">

                            <FormControl fullWidth>
                                <InputLabel htmlFor="my-input">Pincode</InputLabel>
                                <Input
                                    error={pincodeErr}
                                    aria-describedby="my-helper-text"
                                    type="text"
                                    onChange={(e) => {
                                        setPincode(e.target.value);
                                        let pinc = e.target.value;
                                        const regex = /^([+]?[\s0-9]+)?(\d{3}|[(]?[0-9]+[)])?([-]?[\s]?[0-9])+$/i;
                                        if (!pinc || regex.test(pinc) === false || pinc.length != 6) {
                                            setPincodeErr(true);
                                        } else {
                                            setPincodeErr(false);
                                        }
                                    }}
                                    name="pincode"
                                    value={pincode}
                                    required
                                />
                                {pincodeErr && (
                                    <FormHelperText id="my-helper-text" error={true}>
                                        Please enter valid Pincode.
                                    </FormHelperText>
                                )}
                            </FormControl>
                        </div>

                        <div className="col-md-6 col-lg-6 col-sm-12 col-xs-12">

                            <button className="register__btn btn btn-primary float-right mt-3" onClick={sendRequest}>
                                Save
                            </button>


                        </div>
                    </div>
                </div>
            </div>

        </Box>
    )
}

export default ProfileForm